import { useMemo } from "react";
import Styles from "./styles.module.scss";
import Icon from "@Atom/Icon";
import Images from "@Theme/Images";

export default function CandidateDetail({
  candidate,
  setModalType,
  generateContract,
  loadingPDF,
}) {
  const descTemplate = useMemo(() => {
    return [
      {
        title: "Posisi",
        value: candidate?.position,
      },
      {
        title: "Email",
        value: candidate?.email,
      },
      {
        title: "Nomor Handphone",
        value: candidate?.phoneNumber,
      },
      {
        title: "Domisili",
        value: candidate?.domicile,
      },
      {
        title: "Alamat",
        value: candidate?.address,
      },
    ];
  }, [candidate]);

  //   Images
  return (
    <div className={`${Styles.container}`}>
      <div className={Styles.topLineWrapper}>
        <div className={Styles.topLine} />
      </div>
      <div className={Styles.content}>
        <div className={Styles.profileWrapper}>
          <div className={Styles.profileCard}>
            <img
              src={candidate?.profilePicture || Images?.AVA_DEFAULT}
              alt=""
            />
            <span>{candidate?.name}</span>
          </div>
        </div>

        <div className={Styles.descWrapper}>
          {descTemplate?.map((el, i) => (
            <div key={i} className={Styles.desc}>
              <span>{el?.title}</span>
              <span>{el?.value}</span>
            </div>
          ))}
          <button
            disabled={loadingPDF}
            onClick={() => generateContract(candidate)}
          >
            <span>{loadingPDF ? "Loading..." : "Kontrak"}</span>
            <Icon icon="download" size={20} />
          </button>
        </div>
        <div className={Styles.actionsWrapper}>
          <button
            onClick={() => {
              setModalType({
                data: candidate,
                type: "confirm-reject",
              });
            }}
          >
            <Icon icon="cross" size={20} />
          </button>
          <button
            onClick={() => {
              setModalType({
                data: candidate,
                type: "confirm-approve",
              });
            }}
          >
            <Icon icon="check" size={20} />
          </button>
        </div>
      </div>
    </div>
  );
}
